import {
  ExternalConnection,
  ExternalConnectionGoogleProviderInfo,
  ExternalConnectionGoogleSettings,
  ExternalConnectionsProviders,
  ExternalConnectionsTypes,
  ID,
  Roles,
  Timestamp,
} from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { firebaseTimestampToDate } from './firebase-timestamp-to-date';

const coerceProvider = (value: unknown): ExternalConnectionsProviders =>
  Object.values(ExternalConnectionsProviders).includes(
    value as ExternalConnectionsProviders,
  )
    ? (value as ExternalConnectionsProviders)
    : ExternalConnectionsProviders.Google;

const coerceType = (value: unknown): ExternalConnectionsTypes =>
  Object.values(ExternalConnectionsTypes).includes(
    value as ExternalConnectionsTypes,
  )
    ? (value as ExternalConnectionsTypes)
    : ExternalConnectionsTypes.Calendar;

export const externalConnectionConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): ExternalConnection => {
    const data = snapshot.data() as Record<string, unknown>;

    return {
      id: data.id as ID,
      provider: coerceProvider(data.provider),
      providerInfo: data.providerInfo as ExternalConnectionGoogleProviderInfo,
      roles: data.roles as Roles,
      type: coerceType(data.type),
      settings:
        (data.settings as
          | ExternalConnectionGoogleSettings
          | null
          | undefined) ?? null,
      createdAt: firebaseTimestampToDate(data.createdAt as Date) as Timestamp,
      updatedAt: firebaseTimestampToDate(data.updatedAt as Date) as Timestamp,
      lastUsedAt: firebaseTimestampToDate(data.lastUsedAt as Date) as Timestamp,
    };
  },
  toFirestore: (externalConnection: ExternalConnection) => externalConnection,
};
